import UIComponent from "../../common/UIComponent";
import "./index.css";
export default class PlayBtn extends UIComponent {

  constructor(elementId, interfaces) {
    super();
    this.elementId = elementId;
    this.interfaces = interfaces;
    this.isplay = false;
    this.init();

    this.interfaces.on(VhallPlayer.PLAY, res => {
      this.isplay = true;
      this.playBtn.setAttribute("class", "vhallPlayer-playBtn pause");
    });

    this.interfaces.on(VhallPlayer.PAUSE, res => {
      this.isplay = false;
      this.playBtn.setAttribute("class", "vhallPlayer-playBtn play");
    });

  }

  init() {
    this.playBtn = document.createElement("span");
    this.playBtn.setAttribute("class", "vhallPlayer-playBtn play");
    this.playBtn.onclick = this.handlPlayBtnClick.bind(this);
    this.appendChild(this.elementId, this.playBtn);
  }

  handlPlayBtnClick() {
    !this.isplay ? this.interfaces.play() : this.interfaces.pause();
  }

}